import type { FC } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

import CommentIcon from 'src/assets/svg/followup/changelog/Comment.svg';

import ChangelogRow from './ChangelogRow';
import { styles } from './styles';
import type { CommentEntry } from './types';

interface ChangelogCommentProps {
  entry: CommentEntry;
}

const ChangelogComment: FC<ChangelogCommentProps> = ({ entry }) => {
  const { t } = useTranslation('followUp');

  return (
    <ChangelogRow
      authorName={entry.author || t('changelog.deletedUser')}
      date={new Date(Date.parse(entry.createdAt))}
      actionDescription={t('changelog.commented')}
      icon={{
        src: CommentIcon,
        alt: t('changelog.iconAlt.comment'),
      }}
    >
      <Box sx={styles.changelogCommentBox}>{entry.contents}</Box>
    </ChangelogRow>
  );
};

export default ChangelogComment;
